import type { ComponentProps } from "react";

import { getInitials } from "../lib";
import type { UserEntity } from "../model";

import { cn } from "~/shared/ui";
import { Avatar, AvatarFallback } from "~/shared/ui/avatar";

type Props = ComponentProps<typeof Avatar> & {
  user: Pick<UserEntity.Schema, "firstName" | "lastName">;
  fallbackProps?: ComponentProps<typeof AvatarFallback> | undefined;
};

function UserAvatar({
  user,
  className,
  fallbackProps: { className: fallbackClassName, ...fallbackProps } = {},
  ...props
}: Props) {
  const initials = getInitials(user);

  return (
    <Avatar className={cn("size-12", className)} {...props}>
      <AvatarFallback
        className={cn("text-primary-foreground bg-primary-lighter font-bold", fallbackClassName)}
        {...fallbackProps}
      >
        {initials}
      </AvatarFallback>
    </Avatar>
  );
}

export { UserAvatar };
